// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1807":"2163514d","1909":"3af9789f","2262":"4c32e073","4929":"2163514d","6152":"2163514d"}[chunkId] + ".chunk.css";
};